export type AvailableLanguages = 'en' | 'fr'
export const LocalStorageLangKey = 'lng'